import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=18c5bf05"
import script from "./CampaignList.vue?vue&type=script&lang=js"
export * from "./CampaignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports